import React, { useContext } from "react";
import { TitleWrapper, TitleText, StyledButton } from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";
import { TitleBar } from "../../../configs/outsourceOrder";
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { OUTSOURCE_ORDER_CREATE_ROLES } from "../../../configs/outsourceOrderPermissions";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = OUTSOURCE_ORDER_CREATE_ROLES.includes(role);

    const onClickAddButton = () => {
        navigate("/outsource-orders/create?returnTab=outsource%20orders");
    };

    return (
        <TitleWrapper>
            <TitleText>{TitleBar.title}</TitleText>
            {canCreate && (
                <StyledButton variant="contained" onClick={onClickAddButton}>
                    <AddIcon />
                    {TitleBar.addButtonText}
                </StyledButton>
            )}
        </TitleWrapper>
    );
};

export default Title;
